import React, { useState, useRef, useEffect } from "react";
import styled from "styled-components";

export const ButtonSecondary = ({
  style = {},
  className = "",
  children,
  onClick,
  disabled = false,
  loading = false,
  outline = false,
  bgColor = "#03B0F7",
  bgActiveColor = "#009AD9",
  buttonLoader = false,
}) => {
  const [manualLoading, setManualLoading] = useState(false);
  const isMounted = useRef(true);

  useEffect(() => {
    return () => {
      isMounted.current = false;
    };
  }, []);

  const handleClick = async () => {
    try {
      if (isMounted.current) {
        setManualLoading(true);
      }
      await onClick();
    } catch (err) {
      console.log("Component: ButtonSecondary: ", err);
    } finally {
      if (isMounted.current) {
        setManualLoading(false);
      }
    }
  };

  return (
    <ButtonPrimaryStyled
      className={`${className} ${outline ? "outline" : ""}`}
      style={style}
      disabled={disabled || loading || manualLoading}
      bgColor={bgColor}
      bgActiveColor={bgActiveColor}
      onClick={handleClick}
    >
      {buttonLoader ? (
        <>
          <span className="spinner-border spinner-border-sm"></span>
          <span className="ml-1">{children}</span>
        </>
      ) : [loading, manualLoading].includes(true) ? (
        <>
          <span className="spinner-border spinner-border-sm"></span>
          <span> In progress...</span>
        </>
      ) : (
        children
      )}
    </ButtonPrimaryStyled>
  );
};

export default ButtonSecondary;

const ButtonPrimaryStyled = styled.button`
  width: 100%;
  height: 100%;
  background: ${(props) => props.bgColor};
  color: #ffffff;
  padding: 5px 10px;
  font-style: normal;
  font-weight: 600;
  font-size: 12px;
  line-height: 19px;
  border: none;
  box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.1);
  border-radius: 4px;

  &.outline {
    background: ${() => (false ? "#e8f5fc" : "#FFF")};
    border: 1px solid ${(props) => props.bgColor};
    color: ${(props) => props.bgColor};
  }

  &:disabled {
    opacity: 0.5;
  }
  &:focus {
    outline: none;
    background-color: ${(props) => props.bgActiveColor};
  }
  &:active {
    background-color: ${(props) => props.bgActiveColor};
  }
  &:hover {
    background-color: ${(props) => props.bgActiveColor};
  }
  &.btn-primary.disabled,
  &.btn-primary:disabled {
    background-color: ${(props) => props.bgActiveColor};
  }
  &.outline:hover,
  &.outline:active {
    background-color: ${(props) => props.bgColor};
    color: #fff;
    & svg {
      fill: #fff;
    }
  }
  &:disabled {
    opacity: 0.5;
  }
`;
